export default {
  except: [
    'app',
    'router-view',
    'transition',
    'transition-slide',
    'fill-arrow-icon',
    'review-status-icons',
    'myfonts-short-circle-icon',
    'upload-fonts-icon',
    'upload-poster-icon',
    'animation-processing',
    'load-animation',
    'clock-icon',
    'download-icon',
    'error-icon',
    'trash-icon',
    'ok-icon',
    'new-icon',
    'myfonts-icon',
    'warning-icon',
    'grid-view',
    'fou-errors',
    'fou-navigation',
    'fou-overlay',
    'fou-footer',
    'fou-group',
    'fou-accordion',
    'fou-accordion-item',
    'v-grid',
    'v-row',
    'v-col'
  ],
  excludeRoot: 'app'
}
